/**
 * 본문 이미지 대체텍스트의 제품 안전 상한.
 *
 * HTML 표준의 길이 제한이 아니라, 본문·캡션 전체가 alt 에 잘못 저장돼
 * 스크린리더와 검색 결과를 오염시키는 사고를 막기 위한 RootTale 계약이다.
 */
export const IMAGE_ALT_MAX_LENGTH = 160;

/**
 * 이미지 alt 를 한 줄 설명으로 정규화한다.
 *
 * - 문자열이 아니면 빈 alt
 * - 개행·연속 공백을 한 칸으로 축약
 * - 160자를 넘으면 말줄임표를 포함해 상한 안에서 자름
 */
export function normalizeImageAlt(value: unknown): string {
  if (typeof value !== "string") return "";
  const normalized = value.replace(/\s+/g, " ").trim();
  const characters = Array.from(normalized);
  if (characters.length <= IMAGE_ALT_MAX_LENGTH) return normalized;

  const visible = characters
    .slice(0, IMAGE_ALT_MAX_LENGTH - 1)
    .join("")
    .trimEnd();
  return `${visible}…`;
}
